export const SESSIONLOG_LIST_REQUEST = 'SESSIONLOG_LIST_REQUEST';

export const SESSIONLOG_LIST = 'SESSIONLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_SESSIONLOG_PAGINATION = 'SET_SESSIONLOG_PAGINATION';

export const SESSIONLOG_PAGE_RESET = 'SESSIONLOG_PAGE_RESET';
